var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar-component'),_c('div',{staticClass:"bg-container"},[_c('dispute-detail-content-layout',{attrs:{"texts":_vm.texts}})],1),_c('footer-component'),_c('whatsapp-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }